import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError, AxiosRequestConfig } from "axios"

import repo from "@/lib/repository";
import { UserNotificationDto } from "@/lib/types";
import { validateServerError } from "@/lib/utils";

/** The bell shows the newest notifications only. */
export const NOTIFICATIONS_LIMIT = 50;

export const getNotifications = createAsyncThunk("notifications/get/all", async (_, { rejectWithValue }) => {
  try {
    const config: AxiosRequestConfig = {
      params: {
        sort: 'created',
        direction: 'desc',
        limit: NOTIFICATIONS_LIMIT,
      }
    }
    const { data } = await repo.get<UserNotificationDto[]>("/specialists/notifications/all", config);

    return data;
  }
  catch (error: any | AxiosError) {
    return rejectWithValue(validateServerError(error));
  }
});

export const getUnreadNotificationsCount = createAsyncThunk("notifications/get/unread-count", async (_, { rejectWithValue }) => {
  try {
    const { data } = await repo.get<{ count: number }>("/specialists/notifications/unread-count");

    return data.count;
  }
  catch (error: unknown) {
    return rejectWithValue(validateServerError(error));
  }
});

export const readNotifications = createAsyncThunk("notifications/get/read", async (_, { rejectWithValue }) => {
  try {
    const { data } = await repo.post<UserNotificationDto[]>("/specialists/notifications/read");

    return data;
  }
  catch (error: any | AxiosError) {
    return rejectWithValue(validateServerError(error));
  }
});
